import { LuSparkles } from "react-icons/lu";
import { BsLightningCharge } from "react-icons/bs";
import { FaRegEdit, FaTrash } from "react-icons/fa";
import './styles.css';

export default function ChallengeCard({ 
    id,
    description,
    origin,
    icon = "sparkles",
    isSelected = false,
    disabled = false,
    onSelect,
    onHover,
    onEdit,
    onDelete,
    className = ""
}) {
    const handleClick = () => {
        if (!disabled && onSelect) {
            onSelect(id);
        }
    };

    const handleMouseEnter = () => {
        if (!disabled && onHover) {
            onHover(id, true);
        }
    };

    const handleMouseLeave = () => {
        if (!disabled && onHover) {
            onHover(id, false);
        }
    };

    const handleEdit = (e) => {
        e.stopPropagation();
        if (!disabled && onEdit) {
            onEdit(id);
        }
    };

    const handleDelete = (e) => {
        e.stopPropagation();
        if (!disabled && onDelete) {
            onDelete(id);
        }
    };

    const getIcon = () => {
        if (icon === "lightning") {
            return <BsLightningCharge size={16} />;
        }
        return <LuSparkles size={16} />;
    };

    const getTypeLabel = (origin) => {
        switch (origin) {
            case "challenge":
                return "Gerador de desafio";
            case "brainstorm":
                return "Brainstorm";
            default:
                return "Ferramenta de inovação";
        }
    };

    return (
        <div 
            className={`challenge-card ${isSelected ? 'selected' : ''} ${disabled ? 'disabled' : ''} ${className}`}
            onClick={handleClick}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            role="button"
            tabIndex={disabled ? -1 : 0}
            aria-pressed={isSelected}
            aria-disabled={disabled}
        >
            <div className="challenge-card-actions">
                <button
                    className="challenge-action-btn challenge-edit-btn"
                    onClick={handleEdit}
                    title="Editar desafio"
                    aria-label="Editar desafio"
                >
                    <FaRegEdit size={14} />
                </button>
                <button
                    className="challenge-action-btn challenge-delete-btn"
                    onClick={handleDelete}
                    title="Excluir desafio"
                    aria-label="Excluir desafio"
                >
                    <FaTrash size={14} />
                </button>
            </div>

            <div className="challenge-card-content">
                <p className="challenge-description">
                    {description}
                </p>
                
                <div className="challenge-footer">
                    <div className="challenge-icon">
                        {getIcon()}
                    </div>
                    <span className="challenge-origin-label">
                        {getTypeLabel(origin)}
                    </span>
                </div>
            </div>
        </div>
    );
}